// Organization, People and Roles and access for a brand's own logins, in the
// Maruti Service Desk design.
//
// No tenant id: the API answers for the signed-in brand and narrows everything
// to what this login's access policy already reaches (see GET /api/organization).
// A Regional Head sees their regions and nobody else's. The logic is shared
// with Super Admin's pages (SuperAdmin/useOrgEditors, useRoleForm), which keep
// their own look.

import OrganizationPage from "./msd/org/OrganizationPage";
import PeoplePage from "./msd/org/PeoplePage";
import RolesPage from "./msd/org/RolesPage";
import { useOrgAccess } from "./msd/org/kit";
import { CARD } from "../components/msd/ui";

/** Regions, dealers and workshops are one page now; each route still opens
 *  only the parts this login could open before. */
function Organization() {
  const access = useOrgAccess();
  if (!access.regions.see && !access.dealers.see && !access.workshops.see) {
    return (
      <div className={`${CARD} px-[26px] py-6`}>
        <p className="m-0 text-[15px] text-msd-muted">Organization isn&apos;t available for your role.</p>
      </div>
    );
  }
  return <OrganizationPage access={access} />;
}

export const OrgRegions = Organization;
export const OrgDealers = Organization;
export const OrgWorkshops = Organization;

export function OrgPeople() {
  const access = useOrgAccess();
  return <PeoplePage readOnly={!access.people.edit} />;
}

export function OrgRoles() {
  const access = useOrgAccess();
  return <RolesPage canEdit={access.roles.edit} canSeePeople={access.people.see} />;
}
